package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Cursor.Companion.Pointer
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.*

// --- Model section ---

val ModelViewButtonMarginStyle = CssStyle {
    base          { Modifier.margin(top = 15.px) }
    Breakpoint.MD { Modifier.margin(top = 30.px) }
}

val ViewButtonResponsiveStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .padding(topBottom = 15.px, leftRight = 10.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(30.px)
            .padding(topBottom = 40.px, leftRight = 35.px)
    }
}
val ViewButtonModalStyle = CssStyle {
    base {
        Modifier
            .borderRadius(44.px)
            .fontSize(14.px)
            .padding(topBottom = 15.px, leftRight = 10.px)
            .margin(top = 15.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(30.px)
            .padding(topBottom = 40.px, leftRight = 35.px)
            .margin(top = 30.px)
    }
}
// --- Carousel: mobile vs desktop containers (même pattern que Desktop/MobileMenu) ---

val MobileCarouselContainerStyle = CssStyle {
    base { Modifier.display(DisplayStyle.Flex) }
    Breakpoint.MD { Modifier.display(DisplayStyle.None) }
}

val DesktopCarouselContainerStyle = CssStyle {
    base { Modifier.display(DisplayStyle.None) }
    Breakpoint.MD { Modifier.display(DisplayStyle.Flex) }
}

// --- Chevrons ---

val ChevronButtonLeftPositionStyle = CssStyle {
    base          { Modifier.left(60.px) }
    Breakpoint.MD { Modifier.left(10.px) }
}

val ChevronButtonRightPositionStyle = CssStyle {
    base          { Modifier.right(60.px) }
    Breakpoint.MD { Modifier.right(10.px) }
}

val ViewButtonLabelShortStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .display(DisplayStyle.Inline)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(30.px)
            .display(DisplayStyle.None)
    }
}

// Masque le texte court sur desktop
val ViewButtonLabelLongStyle = CssStyle {
    base { Modifier.fontSize(14.px).display(DisplayStyle.None) }
    Breakpoint.MD { Modifier.fontSize(30.px).display(DisplayStyle.Inline) }
}

val ViewButtonBaseStyle = CssStyle {
    base { Modifier.margin(top = 15.px) }
    Breakpoint.MD { Modifier.margin(top = 30.px) }
}


// CoverLetterHeroSection

// BANNIÈRE HÉRO

// OVERLAY POUR LE DARK MODE
val HeroOverlayStyle = CssStyle {
    base {
        Modifier
            .fillMaxSize()
            .position(Position.Absolute)
            .styleModifier {
                property("top", "0")
                property("left", "0")
                property("pointer-events", "none")
                property("transition", "background 200ms ease")
            }
    }
}

// PADDING ET LAYOUT

// TYPOGRAPHIE RESPONSIVE
val MotiveButtonLabelShortStyle = CssStyle {
    base { Modifier.fontSize(14.px).display(DisplayStyle.Inline) }
    Breakpoint.MD { Modifier.fontSize(35.px).display(DisplayStyle.None) }
}

val MotiveButtonLabelLongStyle = CssStyle {
    base { Modifier.fontSize(14.px).display(DisplayStyle.None) }
    Breakpoint.MD { Modifier.fontSize(35.px).display(DisplayStyle.Inline) }
}

val CoverButtonHeroRadiusStyle = CssStyle {
    base { Modifier.borderRadius(22.px) }
    Breakpoint.MD { Modifier.borderRadius(44.px) }
}

// MotivationLetterSection

val ViewMoreButtonArrowStyle = CssStyle {
    base { Modifier.height(20.px) }
    Breakpoint.MD { Modifier.height(40.px) }
}

val ViewMoreLabelShortStyle = CssStyle {
    base { Modifier.fontSize(15.px).display(DisplayStyle.Inline) }
    Breakpoint.MD { Modifier.fontSize(30.px).display(DisplayStyle.None) }
}

val ViewMoreLabelLongStyle = CssStyle {
    base { Modifier.fontSize(15.px).display(DisplayStyle.None) }
    Breakpoint.MD { Modifier.fontSize(30.px).display(DisplayStyle.Inline) }
}

// CountrySection
val CountryTitleMobileTextStyle = CssStyle {
    base { Modifier.fontSize(18.px) }
    Breakpoint.MD { Modifier.fontSize(35.px) }
}

val CountryTitleDesktopTextStyle = CssStyle {
    base { Modifier.fontSize(35.px) }
}
// TYPOGRAPHIE DES DESCRIPTIONS

val CountryButtonLabelShortStyle = CssStyle {
    base { Modifier.fontSize(14.px).display(DisplayStyle.Inline) }
    Breakpoint.MD { Modifier.fontSize(30.px).display(DisplayStyle.None) }
}

val CountryButtonLabelLongStyle = CssStyle {
    base { Modifier.fontSize(14.px).display(DisplayStyle.None) }
    Breakpoint.MD { Modifier.fontSize(30.px).display(DisplayStyle.Inline) }
}

val CountryCardContainerStyle = CssStyle {
    base { Modifier.margin(10.px) }
    Breakpoint.MD { Modifier.margin(20.px) }
}

// Le cercle blanc englobant l'image
val CountryCardCircleStyle = CssStyle {
    base {
        Modifier
            .size(80.px)
            .borderRadius(116.px)
            .backgroundColor(Colors.White)
    }
    Breakpoint.MD {
        Modifier.size(190.px)
    }
}

// L'image du drapeau
val CountryCardImageStyle = CssStyle {
    base { Modifier.width(48.px) }
    Breakpoint.MD { Modifier.width(112.px) }
}

// Le texte du nom de CV
val CountryCardTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(12.px)
            .margin(top = 8.px)
    }

    // Assure que le SpanText Kobweb hérite bien de la taille du parent
    cssRule(" span") {
        Modifier.styleModifier { property("font-size", "inherit") }
    }

    Breakpoint.MD {
        Modifier
            .fontSize(20.px)
            .margin(top = 15.px)
    }
}

// TestimonialSection
val TestimonialCardContainerStyle = CssStyle {
    base { Modifier.width(260.px) }
    Breakpoint.MD { Modifier.width(300.px) }
}

// AVATAR / IMAGE
val TestimonialCardImageStyle = CssStyle {
    base {
        Modifier
            .size(80.px)
            .borderRadius(97.px)
    }
    Breakpoint.MD {
        Modifier.size(120.px)
    }
}

// COMMENTAIRE
val TestimonialCardCommentStyle = CssStyle {
    base {
        Modifier
            .fontSize(10.px)
            .margin(top = 15.px)
    }
    cssRule(" span") {
        Modifier.styleModifier { property("font-size", "inherit") }
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

// ÉTOILES DE NOTATION
val TestimonialCardStarStyle = CssStyle {
    base {
        Modifier
            .size(15.px)
            .margin(leftRight = 5.px)
    }
    Breakpoint.MD {
        Modifier
            .size(25.px)
            .margin(leftRight = 10.px)
    }
}

// NOM ET POSTE (Règles communes et responsives)
val TestimonialCardNameStyle = CssStyle {
    base {
        Modifier
            .fontSize(12.px)
            .margin(top = 10.px)
    }
    cssRule(" span") {
        Modifier.styleModifier { property("font-size", "inherit") }
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

val TestimonialCardJobStyle = CssStyle {
    base {
        Modifier
            .fontSize(12.px)
            .margin(top = 5.px)
    }
    cssRule(" span") {
        Modifier.styleModifier { property("font-size", "inherit") }
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

// STYLES DE MASQUAGE/AFFICHAGE MOBILE VS DESKTOP
val TestimonialMobileContainerStyle = CssStyle {
    base { Modifier.display(DisplayStyle.Flex).fillMaxWidth() }
    Breakpoint.MD { Modifier.display(DisplayStyle.None) }
}

val TestimonialDesktopContainerStyle = CssStyle {
    base { Modifier.display(DisplayStyle.None) }
    Breakpoint.MD { Modifier.display(DisplayStyle.Flex) }
}

// RANGÉE DESKTOP
val TestimonialDesktopRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .maxWidth(1200.px)
            .margin(bottom = 40.px)
    }
}
